// extracted by mini-css-extract-plugin
module.exports = {"input":"_5a28450529--input--qT5Pp"};